__turbopack_context__.v({
  "nextLiveClipContainer": "NextLiveClip-module-scss-module__pqzTCa__nextLiveClipContainer",
  "nextLiveClipStartingNow": "NextLiveClip-module-scss-module__pqzTCa__nextLiveClipStartingNow",
  "playlistTrackClipTitle": "NextLiveClip-module-scss-module__pqzTCa__playlistTrackClipTitle",
  "playlistTrackDetails": "NextLiveClip-module-scss-module__pqzTCa__playlistTrackDetails",
  "selected": "NextLiveClip-module-scss-module__pqzTCa__selected",
});
